import { TextField, TextFieldProps } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useController, useFormContext, RegisterOptions } from 'react-hook-form';

type FormTextFieldProps = TextFieldProps & {
  name: string;
  rules?: RegisterOptions;
};

function handleWheel(event: WheelEvent) {
  event.preventDefault();
}

const FormTextField = ({ name, defaultValue = '', type, rules, sx, ...rest }: FormTextFieldProps) => {
  const { field } = useController({ name, defaultValue, rules });
  const {
    formState: { errors },
  } = useFormContext<{ [key: string]: string }>();
  const error = errors[name];

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = inputRef.current;
    if (input && type === 'number') {
      input.addEventListener('wheel', handleWheel, { passive: false });
    }
    return () => {
      input?.removeEventListener('wheel', handleWheel);
    };
  }, [inputRef, type]);

  return (
    <TextField
      required={Boolean(rules?.required)}
      error={Boolean(error)}
      type={type}
      helperText={error?.message}
      color="info"
      inputProps={{ ref: inputRef }}
      autoComplete="off"
      {...field}
      {...rest}
      sx={{
        div: {
          backgroundColor: (t) => t.palette.background.paper,
        },
        ...sx,
      }}
    />
  );
};

export default FormTextField;
